// Colours for canvas charts, which can't read CSS variables. The shared ones
// match src/Styles/tokens.scss; charts that follow the theme read the CSS
// variable at runtime (useChartTheme in Components/Charts/useEChart) and fall
// back to these.

/** Theme colours from tokens.scss, for fallbacks when no stylesheet is loaded */
export const themeColors = {
  dark: {
    text: "#f4f4f4",
    muted: "#9a9a9a",
    success: "#92d4ae",
    warning: "#e6c17b",
  },
  light: {
    text: "#171717",
    muted: "#5a5a5a",
    success: "#216b42",
    warning: "#805900",
  },
} as const;

/** Fixed colours: the brand blue and the series colours charts share */
export const palette = {
  white: "#ffffff",
  black: "#000000",
  gray: "#5b5b5b",
  midGray: "#808080",
  brand: "#007df2",
  red: "#ee3529",
  orange: "#ff8a00",
  amber: "#ffa929",
  green: "#39b845",
  forest: "#349a3e",
  emerald: "#34b27a",
  grass: "#28a745",
  leaf: "#3c9e00",
  lime: "#00ff00",
  mint: "#0affa7",
  cyan: "#00b8f2",
  sky: "#74bcff",
  indigo: "#7581bd",
  violet: "#a076e0",
  purple: "#b009ff",
  magenta: "#f200ae",
  pink: "#df62ae",
  rose: "#ff4683",
  scarlet: "#ff0000",
  tangerine: "#ff7c04",
  copper: "#ed8d3c",
  peach: "#ff9e44",
  yellow: "#ffff00",
} as const;

/** Border of the default brand-blue bars and rings */
export const CHART_BORDER = `${palette.brand}99`;

/** Series colours in order; statuses and locations take them by index */
export const CHART_PALETTE = [
  palette.brand,
  palette.red,
  palette.amber,
  palette.pink,
  "#6a5acd",
  "#ff6347",
  "#8b4513",
  "#ffa07a",
];

/** `rgba(r, g, b, alpha)` from a #rrggbb colour */
export const rgba = (hex: string, alpha: number) => {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
